<template>
  <div class="m-15" v-if="items.length > 0">
    <b-table
      striped
      bordered
      :busy="isBusy"
      hover
      :items="items"
      :fields="fields"
      @row-clicked="rowHandler"
    >
      <template v-slot:cell(isRaffleAlreadyBound)="data">
        <b-badge v-if="data.item.isRaffleAlreadyBound == false" variant="danger">
          {{ data.item.isRaffleAlreadyBound == false ? "Não" : "Sim" }}
        </b-badge>
        <b-badge v-else variant="success">
          {{ data.item.isRaffleAlreadyBound == false ? "Não" : "Sim" }}
        </b-badge>
      </template>

      <div slot="table-busy" class="text-center text-danger my-2">
        <strong>Carregando...</strong>
      </div>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";
import * as config from "@/config.json";
import moment from "moment";

export default {
  name: "vincularpromocao",
  components: {},
  data: () => {
    return {
      isBusy: false,
      items: [],
      fields: [
        { key: "data_inicial", label: "Data Inicial" },
        { key: "data_final", label: "Data Final" },
        { key: "data_sorteio", label: "Data Sorteio" },
        { key: "descricao_sorteio", label: "Descrição Sorteio" },
        { key: "descricao_premios", label: "Descrição Premios" },
        { key: "isRaffleAlreadyBound", label: "Vinculado" },
      ],
    };
  },
  methods: {
    rowHandler(record) {
      localStorage.setItem("selecionado", record.id_local);
      localStorage.setItem(
        "data_inicial",
        moment(record.data_inicial_padrao).format()
      );
      localStorage.setItem(
        "data_final",
        moment(record.data_final_padrao).format()
      );

      if (record.isRaffleAlreadyBound) {
        this.$alert(
          "O sorteio escolhido já está vinculado. Necessário desvinculá-lo para novo vínculo do sorteio!",
          "Impossível Vincular",
          "error"
        );
        this.$emit("can-continue", { value: false });
      } else {
        this.$emit("can-continue", { value: true });
      }
    },

    async getSorteios() {
      const url = `${config.default.servidor}/gerencial/sorteios/${localStorage
        .getItem("enterprise_id")
        .toString()}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          if (response.data.data.length > 0) {
            this.items = response.data.data;
            this.isLoading = false;
            this.isBusy = false;
          } else {
            await this.$alert(
              "Não encontramos sorteios no seu ERP Accesys",
              "Erro ao buscar sorteios",
              "error"
            );

            this.$router.go(-1);
          }
        }
      } catch (error) {
        console.log({ error });
        this.isBusy = false;
        await this.$alert(
          "Não encontramos sorteios no seu ERP Accesys",
          "Erro ao buscar sorteios",
          "error"
        );
      }
    },
  },
  async beforeMount() {
    this.isBusy = true;

    await this.getSorteios();
  },
  mounted() {
    this.$emit("update:title", "titulo");
  },
};
</script>

<style>
.m-15 {
  margin: 15px;
}
</style>

